import { useQuery } from "@tanstack/react-query";
import getAvailableDays, { AvailableDaysParams } from "api/bookAppointmentOnline/get-available-days";

type HookParams = {
    enabled: boolean;
} & AvailableDaysParams;

export default function useGetAvailableDays({ doctorId, typeId, month, context, contextId, enabled }: HookParams) {
    return useQuery({
        queryKey: ["availableDaysList", doctorId, typeId, month, context, contextId],
        queryFn: () => getAvailableDays({ doctorId, typeId, month, context, contextId }),
        enabled: enabled && !!context && !!month,
    });
}
